export const KEY_PRESSED = "KEY_PRESSED" as const;
export const UPDATE_STRING = "UPDATE_STRING" as const;

export interface IStringResponse {
  message_type: string;
  text: string;
  typing_speed?: number;
  accuracy?: number;
  error_rate?: number;
}

export interface IUpdateStringAction {
  readonly type: typeof UPDATE_STRING;
  readonly payload: IStringResponse;
}

export const keyPressed = (value: string) => ({
  type: KEY_PRESSED,
  payload: value,
});

export const updateString = {type: UPDATE_STRING};

export type TTrainerActions = IUpdateStringAction | ReturnType<typeof keyPressed>;
